import { VendorTypeEnum } from "@finway-group/shared/lib/models"
import { useState } from "react"
import { useVendorDropdown } from "~Shared/queries/vendors/vendor.queries"

export const useFetchVendorDropdown = ({ searchTerm, dropdownType }: { searchTerm: string; dropdownType: VendorTypeEnum }) => {
    const [searchString, setSearchString] = useState(searchTerm)
    const isVendorDropdownQueryEnabled = dropdownType === VendorTypeEnum.VENDOR

    const useInfiniteQueryResult = useVendorDropdown(searchString, isVendorDropdownQueryEnabled)

    return [{ useInfiniteQueryResult, searchString }, { setSearchString }] as const
}
